
// export async function googleTransliterate(text, lang = "hi") {
//   if (!text || text.trim() === "") {
//     return "";
//   }

//   try {
//     // 🔐 Step 1: numbers extract + replace with pure symbol token
//     const numbers = [];
//     const TOKEN = "§§§"; // ❗ only symbols (no letter, no digit)

//     let safeText = text.replace(/\d+(\.\d+)?/g, (match) => {
//       numbers.push(match);
//       return TOKEN;
//     });

//     // 🔤 Step 2: transliterate
//     const response = await fetch(
//       `https://inputtools.google.com/request?text=${encodeURIComponent(
//         safeText
//       )}&itc=${lang}-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8&app=demopage`
//     );

//     const data = await response.json();

//     let convertedText = safeText;

//     if (data && data[0] === "SUCCESS" && data[1]?.[0]?.[1]?.[0]) {
//       convertedText = data[1][0][1][0];
//     }

//     // 🔓 Step 3: restore numbers IN ORDER
//     numbers.forEach((num) => {
//       convertedText = convertedText.replace(TOKEN, num);
//     });

//     return convertedText;
//   } catch (error) {
//     console.error("Transliteration error:", error);
//     return text;
//   }
// }

// export default googleTransliterate;




export async function googleTransliterate(text, lang = "hi") {
  if (!text || text.trim() === "") {
    return { text: "", suggestions: [] };
  }

  try {
    const response = await fetch(
      `https://inputtools.google.com/request?text=${encodeURIComponent(
        text
      )}&itc=${lang}-t-i0-und&num=5`
    );

    const data = await response.json();

    if (data && data[0] === "SUCCESS") {
      const hindiSuggestions = data[1][0][1] || [];

      return {
        text: hindiSuggestions[0] || "",
        suggestions: [
          text,                // English
          ...hindiSuggestions  // Hindi suggestions
        ],
      };
    }

    return { text: text, suggestions: [text] };
  } catch (error) {
    console.error("Transliteration error:", error);
    return { text: text, suggestions: [text] };
  }
}
export default googleTransliterate;